import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Tabs, TabsOptions } from '@com-delta-omnichannel/mach-core-js';
@Component({
  selector: 'idp-flyout-tracker-base',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flyout-tracker-base.component.html',
  styleUrl: './flyout-tracker-base.component.scss'
})
export class FlyoutTrackerBaseComponent {
  @Output() footerTracking = new EventEmitter<HTMLElement>();

  selectedTab = 1;
  tabsInstance!: Tabs;
  tabsOptions: TabsOptions = {
    id: 'flyout-tabs',
    tabVariant: 'standard',
    tabSize: 'small',
    tabWidth: 'fixed',
    tabItems: []
  };

  focusTab(focusable: HTMLElement[], e: KeyboardEvent): void {
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const shift = e.shiftKey;
    if (shift) {
      if (e.target === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  trackData(event: Event): void {
    const element = event.currentTarget as HTMLElement;
    this.footerTracking.emit(element);
  }

  trackTabAnalytics(tabIndex: number): HTMLElement | undefined {
    const tabButton = document.querySelector(
      `#flyout-tabs button[id="tab-${tabIndex}"]`
    ) as HTMLElement;
    if (tabButton) {
      const tabLabelElement = tabButton.querySelector('.item-label-text');
      const tabName =
        tabLabelElement?.textContent?.toLowerCase() || `tab-${tabIndex}`;
      tabButton.setAttribute(
        'data-acdl-action',
        `skymiles flyout:${tabName}:tab`
      );
      tabButton.setAttribute('data-acdl-name', tabName);
      tabButton.setAttribute(
        'data-acdl-page-section',
        'header:skymiles flyout'
      );
      return tabButton;
    }
    return undefined;
  }
}
